import React, { useState, useEffect } from 'react';
/* Original: import { ChevronLeft, ChevronRight, Wrench, Clock, Shield, Star } from 'lucide-react'; */
import { ChevronLeft, ChevronRight, Wrench } from 'lucide-react';

import imagenhome1 from '../assets/images/imagenhome1.png';
import imagenhome2 from '../assets/images/imagenhome2.png';
import imagenhome3 from '../assets/images/imagenhome3.png';
import imagenhome4 from '../assets/images/imagenhome4.png';
import imagenhome5 from '../assets/images/imagenhome5.png';

const slides = [
  {
    id: 1,
    title: "¿Qué le pasa a tu carro?",
    subtitle: "Rueda pero algo anda mal, está inmovilizado o requiere mantenimiento",
    description: "Sin costo de afiliación, somos tu plataforma de diagnóstico y solución automotriz",
    image: imagenhome1, //.png?auto=compress&cs=tinysrgb&w=1920&h=1080&fit=crop",
    cta: "Solicitar ayuda ahora",
    features: ["Respuesta rápida", "Mecánicos recomendados", "Servicios confiables"]
  },
  {
    id: 2,
    title: "Red de confianza",
    subtitle: "Mecánicos y talleres al servicio de tu comodidad",
    description: "Atención a domicilio y especializada en taller",
    image: imagenhome2, //.png?auto=compress&cs=tinysrgb&w=1920&h=1080&fit=crop",
    cta: "Solicitar ayuda ahora",
    features: ["Respuesta rápida", "Mecánicos recomendados", "Servicios confiables"]
  },
  {
    id: 3,
    title: "Diagnóstico confiable",
    subtitle: "Para tu comodidad y agilidad",
    description: "Antes que el carro se accidente, conecta y pide una revisión a domicilio",
    image: imagenhome3, // .jpeg?auto=compress&cs=tinysrgb&w=1920&h=1080&fit=crop",
    cta: "Solicitar diagnóstico",
    features: ["Atención personalizada", "Seguimiento del mantenimiento", "Asesoría permanente"]
  },
  {
    id: 4,
    title: "Prevenir antes de lamentar",
    subtitle: "Mantén al día los servicios de tu carro",
    description: "Muévete con tranquilidad y ten a mano el contacto de RECARX PLUS",
    image: imagenhome4, // jpeg?auto=compress&cs=tinysrgb&w=1920&h=1080&fit=crop",
    cta: "Solicitar ayuda ahora",
    features: ["Atención personalizada", "Respuesta oportuna", "Precios transparentes"]
  },
  {
    id: 5,
    title: "Soluciones en un clic",
    subtitle: "Todo lo que el carro necesita, justo cuando lo necesita",
    description: "Diagnóstico, Atención Primaria de Mecánica, especializada en taller y mantenimiento preventivo.",
    image: imagenhome5, // jpeg?auto=compress&cs=tinysrgb&w=1920&h=1080&fit=crop",
    cta: "Solicitar ayuda ahora",
    features: ["Atención personalizada", "Respuesta oportuna", "Seguimiento"]
  }
];

interface HeroProps {
  onServiceRequest: () => void;
}

export const Hero: React.FC<HeroProps> = ({ onServiceRequest }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => { setCurrentSlide((prev) => (prev + 1) % slides.length); }, 10000);
    return () => clearInterval(timer);
  }, []);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <section className="relative h-[600px] md:h-[700px] overflow-hidden">
      {slides.map((slide, index) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-transparent z-10" />
          <img
            src={slide.image}
            alt={slide.title}
            className="w-full h-full object-cover"
          />
          
          <div className="absolute inset-0 z-20 flex items-center">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
              <div className="max-w-2xl">
                <h1 className="text-4xl md:text-6xl font-bold text-white mb-4 leading-tight">
                  {slide.title}
                </h1>
                <p className="text-xl md:text-2xl text-orange-400 mb-4 font-medium">
                  {slide.subtitle}
                </p>
                <p className="text-lg text-gray-200 mb-8 leading-relaxed">
                  {slide.description}
                </p>

                <div className="flex flex-col sm:flex-row gap-4">
                  <button
                    onClick={onServiceRequest}
                    className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-colors flex items-center justify-center space-x-2"
                  >
                    <Wrench className="h-5 w-5" />
                    <span>{slide.cta}</span>
                  </button>
                  {/*<button className="border-2 border-white text-white hover:bg-white hover:text-gray-900 px-8 py-4 rounded-lg font-semibold text-lg transition-colors">
                    Ver Cómo Funciona
                  </button>*/}
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}

      {/* Navigation Arrows */}
      <button
        onClick={prevSlide}
        className="absolute left-4 top-1/2 transform -translate-y-1/2 z-30 bg-black/30 hover:bg-black/50 text-white p-3 rounded-full transition-colors"
      >
        <ChevronLeft className="h-6 w-6" />
      </button>
      <button
        onClick={nextSlide}
        className="absolute right-4 top-1/2 transform -translate-y-1/2 z-30 bg-black/30 hover:bg-black/50 text-white p-3 rounded-full transition-colors"
      >
        <ChevronRight className="h-6 w-6" />
      </button>

      {/* Slide Indicators */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-30 flex space-x-3">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`w-3 h-3 rounded-full transition-colors ${
              index === currentSlide ? 'bg-orange-400' : 'bg-white/40 hover:bg-white/60'
            }`}
          />
        ))}
      </div>

      {/* Stats Bar */}
      <div className="absolute bottom-0 left-0 right-0 z-30 bg-gradient-to-r from-blue-600/90 to-blue-700/90 backdrop-blur-sm">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center">
            <div className="text-white">
              <div className="text-2xl font-bold">0</div>
              <div className="text-sm opacity-90">Mecánicos activos en Caracas, Lara y Valencia</div>
            </div>
            <div className="text-white">
              <div className="text-2xl font-bold">30min</div>
              <div className="text-sm opacity-90">Tiempo respuesta</div>
            </div>
            <div className="text-white">
              <div className="text-2xl font-bold">CONFIANZA</div>
              <div className="text-sm opacity-90">Ayuda experta</div>
            </div>
            <div className="text-white">
              <div className="text-2xl font-bold">DISPONIBLE</div>
              <div className="text-sm opacity-90">De lunes a viernes de 8:00 am a 5:00 pm</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};